import { BasicsState } from './State'
import { IResponseUpdateRequestPayload } from 'types'

export const SET_RESPONSE = 'basicsComponent.setResponse'
export const SET_SCHOOL_RESPONSE = 'basicsComponent.setSchoolResponse'
export const SET_RESPONSES = 'basicsComponent.setResponses'
export const ADD_SCHOOL = 'basicsComponent.addSchool'
export const SET_IS_SEARCHING_SCHOOL = 'basicsComponent.setIsSearchingSchool'
export const SET_SCHOOL_SEARCH_RESULT = 'basicsComponent.setSchoolSearchResult'

export function setResponse(payload: IResponseUpdateRequestPayload) {
  return {
    type: SET_RESPONSE,
    payload
  } as const
}

export function setSchoolResponse(payload: any) {
  return {
    type: SET_SCHOOL_RESPONSE,
    payload
  } as const
}

export function setResponses(payload: BasicsState['user']) {
  return {
    type: SET_RESPONSES,
    payload
  } as const
}

export function addSchool() {
  return {
    type: ADD_SCHOOL
  } as const
}

export function setIsSearchingSchool(payload: boolean) {
  return {
    type: SET_IS_SEARCHING_SCHOOL,
    payload
  } as const
}

export function setSchoolSearchResult(payload: any) {
  return {
    type: SET_SCHOOL_SEARCH_RESULT,
    payload
  } as const
}

export type BasicsAction = ReturnType<
  | typeof setResponse
  | typeof setSchoolResponse
  | typeof setResponses
  | typeof addSchool
  | typeof setIsSearchingSchool
  | typeof setSchoolSearchResult
>
